import React, { FC } from 'react'
import styles from './questionBlock.module.scss'

interface QuestionProps {
  id: string
  question: string
  description: string
}

export const QuestionBlock: FC<QuestionProps> = ({
  id,
  question,
  description,
  children
}) => (
  <div className={styles.questionBlock} id={id}>
    <h4 className={styles.header}>
      <span>{question}</span>
      <div
        className='sub header'
        dangerouslySetInnerHTML={{
          __html: description
        }}
      />
    </h4>
    {children}
  </div>
)
